import { useSelector } from 'react-redux';

// Custom hook to get user details from the Redux store
const useUser = () => {
  const user = useSelector((state) => state.user.user); // access user from the Redux store
  return user;
};

export default useUser;
